import styled from 'styled-components';
import { theme } from '../../global';

export const PreviewCaseContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s16};
  flex-direction: column;
`;

export const TextContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s8};
  flex-direction: column;
`;

export const Title = styled.h3`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 20px;
  line-height: 24.38px;
  color: ${theme.colors.primaryText};

  &:hover {
    text-decoration: underline;
    text-decoration-style: solid;
  }
`;

export const PreviewText = styled.span`
  font-family: Montserrat;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  a {
    text-decoration: underline;
    text-decoration-style: solid;
    cursor: pointer;
    white-space: nowrap;
    color: ${theme.colors.blue};
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  span {
    border: 0.94px solid ${theme.colors.lightPurple};
    border-radius: ${theme.spacings.s32};
    padding: ${theme.spacings.s8};
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 12px;
    line-height: 14.63px;
    color: #53555f;
    margin: 0;
  }
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
`;
